import PresenterHost from 'components/presenter-host.vue';
import PresenterRoleHost from 'components/presenter-role-host.vue';
import PresenterViewport from 'components/presenter-viewport.vue';
import SlidesManager from 'components/slides-manager.vue';
import MediaManager from 'components/media-manager.vue';
import PresentationEditor from 'components/presentation-editor.vue';
import Pinboard from 'components/pinboard.vue';
import PresenterViewportGuest from 'components/presenter-viewport-guest.vue';
import Timer from 'components/timer.vue';
import PresenterSettings from 'components/presenter-settings.vue';


// Mirror specific
export default function registerComponents(Vue) {
    Vue.component('presenter-host', PresenterHost);
    Vue.component('presenter-role-host', PresenterRoleHost);
    Vue.component('presenter-viewport', PresenterViewport);
    Vue.component('slides-manager', SlidesManager);
    Vue.component('media-manager', MediaManager);
    Vue.component('presentation-editor', PresentationEditor);
    Vue.component('pinboard', Pinboard);
    Vue.component('presenter-viewport-guest', PresenterViewportGuest);
    Vue.component('timer', Timer);
    Vue.component('presenter-settings', PresenterSettings);
}